import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Nillable, valueOrDefault } from '@web/utils';
import { SelectItem } from '@web/shared/ui';
import { Observable } from 'rxjs';
import { PublicProductSortType } from '../../enums/public-product-sort-type';
import { PublicProductSortTypeSelectItemsProviderService } from '../../providers/public-product-sort-type-select-items-provider.service';
import { PublicSortPanelComponent } from '@web/features/shop';

@Component({
  selector: 'app-public-product-sort-panel',
  imports: [CommonModule, PublicSortPanelComponent],
  templateUrl: './public-product-sort-panel.component.html',
  styleUrl: './public-product-sort-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicProductSortPanelComponent {
  public readonly sortTypeChange = output<Nillable<PublicProductSortType>>();

  protected readonly selectItems$ = this.selectItemsSource();
  protected readonly valueOrDefault = valueOrDefault;

  public constructor(
    private readonly provider: PublicProductSortTypeSelectItemsProviderService,
  ) {}

  private selectItemsSource(): Observable<SelectItem<PublicProductSortType>[]> {
    return this.provider.selectItems();
  }
}
